export const seoText = {
  mounted: (node: HTMLElement): any => {
    setTimeout(() => {
      const wrapper = node.querySelector('.js-seo-text-wrapper') as HTMLElement
      const content = node.querySelector('.js-seo-text-content') as HTMLElement
      const triggerMore = node.querySelector('.js-seo-text-more') as HTMLElement
      const triggerLess = node.querySelector('.js-seo-text-less') as HTMLElement

      if (!triggerMore || !wrapper) return

      if (content.clientHeight > 50) {
        triggerMore.classList.add('is-visible')
      }

      triggerMore.addEventListener('click', () => {
        wrapper.classList.add('is-opened')
        triggerMore.classList.remove('is-visible')
        triggerLess.classList.add('is-visible')
      })

      triggerLess.addEventListener('click', () => {
        wrapper.classList.remove('is-opened')
        triggerLess.classList.remove('is-visible')
        triggerMore.classList.add('is-visible')
      })
    }, 100)
  }
}
